
export function formatCurrency(amount){
  if ((typeof amount === 'undefined') || (amount===null))
    return ''
  var plCurrencyFormat = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
  return plCurrencyFormat.format(amount);  
}

export function formatLocalNumber(amount, fractDigits=2){
  if ((typeof amount === 'undefined') || (amount===null))
    return ''
  var plCurrencyFormat = new Intl.NumberFormat('pl-PL', { style: 'decimal', minimumFractionDigits: fractDigits, maximumFractionDigits: fractDigits });
  return plCurrencyFormat.format(amount);  
}


// WEBPACK FOOTER //
// ./src/utils/Strings.js